import { FileUploadFile } from 'primereact/fileupload';
import appApi from '../../../../../../api/app-api';
import { HttpStatusCode } from 'axios';
import { toast } from 'react-toastify';
import globalConfigStore from '../../../../../../stores/global-config-store';

export const uploadDocFileAndRetrieveUrlOperation = async (
  file: FileUploadFile,
  userId: number,
) => {
  try {
    const fileExtension = file.name.split('.').pop(); // Gets the last part after the last dot
    // TODO change as soon as possible !!
    const asd = await appApi.getDocPreSignUrl(userId, fileExtension);

    const url = asd.data.body.url;
    const urlWithoutQueryParams = url.split('?')[0];

    // Use the URL object to extract just the path
    const parsedUrl = new URL(urlWithoutQueryParams);
    const path = parsedUrl.pathname;

    const fullUrl = `${globalConfigStore.baseFileUrl}${path}`;

    const uploadFileRes = await appApi.uploadFile(url, file);
    if (uploadFileRes.status !== HttpStatusCode.Ok) {
      throw new Error('Upload file is failed');
      toast.error('העלאת הקובץ נכשלה, יש לנסות שוב בעוד מספר רגעים...');
    }

    return fullUrl;
  } catch (e) {
    console.error(`uploadDocFileOperation is failed with the error: ${e}`);
    throw e;
  }
};
